<modal #modal [css-class]="'order-empty-modal'">
    <div class="modal-header">
        <h5 class="modal-title">
            Din kurv er tom
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
            
        </button>
    </div>
    <div class="modal-body pb-0">
        <p>Vi kan konstatere, at din kurv er tom og du vil derfor blive ført tilbage til lodoversigten.</p>

        <button type="button" class="cta cta--primary align-self-end" aria-label="Close" (click)="close()">
            Ok
        </button>

        <p class="mt-3">Oplever du problemer, så kontakt Kundeservice via vores chat, <a style="color: inherit;" href="mailto:kundeservice@klasselotteriet.dk">e-mail</a> eller telefon: 3342 0900</p>
    </div>

    <div class="modal-footer">
        <app-opening-hours></app-opening-hours>
    </div>

</modal>
